import { render, staticRenderFns } from "./FormAssignmentDialog.vue?vue&type=template&id=324c70d9&scoped=true&"
import script from "./FormAssignmentDialog.vue?vue&type=script&lang=js&"
export * from "./FormAssignmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormAssignmentDialog.vue?vue&type=style&index=0&id=324c70d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324c70d9",
  null
  
)

export default component.exports